<div id="more_services" class="more_services" *ngIf="productData.length">
    <div class="ms_header">
        <div class="ms_heading">
            <p class="title">More Services by LegalStack</p>
            <p class="subtitle">Explore other offerings tailored to grow your business</p>
        </div>
        <div class="ms_nav">
            <button type="button" class="swiper-button-prev custom-swiper-btn" aria-label="Previous services">
                <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 6 10" fill="none">
                    <path
                        d="M0.509058 5.0045C0.508334 5.06345 0.520049 5.12191 0.543448 5.17611C0.566848 5.2303 0.601416 5.27904 0.644928 5.31918L4.72101 9.36513C4.90217 9.54496 5.18297 9.54496 5.36413 9.36513C5.54529 9.18531 5.54529 8.90659 5.36413 8.72677L1.60507 4.9955L5.35507 1.27323C5.53623 1.09341 5.53623 0.814685 5.35507 0.634865C5.17391 0.455045 4.89312 0.455045 4.71196 0.634865L0.63587 4.68082C0.54529 4.77073 0.5 4.88761 0.5 4.9955L0.509058 5.0045Z"
                        fill="currentColor" />
                </svg>
            </button>
            <button type="button" class="swiper-button-next custom-swiper-btn" aria-label="Next services">
                <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 6 10" fill="none">
                    <path
                        d="M5.49094 5.0045C5.49167 5.06345 5.47995 5.12191 5.45655 5.17611C5.43315 5.2303 5.39858 5.27904 5.35507 5.31918L1.27899 9.36513C1.09783 9.54496 0.817029 9.54496 0.63587 9.36513C0.45471 9.18531 0.45471 8.90659 0.63587 8.72677L4.39493 4.9955L0.644928 1.27323C0.463768 1.09341 0.463768 0.814685 0.644928 0.634865C0.826087 0.455045 1.10688 0.455045 1.28804 0.634865L5.36413 4.68082C5.45471 4.77073 5.5 4.88761 5.5 4.9955L5.49094 5.0045Z"
                        fill="currentColor" />
                </svg>
            </button>
        </div>
    </div>

    <div class="swiper moreServiceSwiper moreServiceSwiper_new">
        <div class="swiper-wrapper">
            <div class="swiper-slide" *ngFor="let item of productData">
                <div class="services_card" (click)="navigateToProduct(item)" role="button" tabindex="0"
                    (keydown.enter)="navigateToProduct(item)">
                    <div class="img_wrap">
                        <img class="product_img" [src]="item?.productImage" [alt]="item?.productName" loading="lazy" />
                    </div>
                    <div class="product_detail">
                        <p class="product_title">{{item?.productName}}</p>
                        <button type="button" class="view_btn" (click)="$event.stopPropagation(); navigateToProduct(item)">
                            <span>View Details</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 6 10" fill="none">
                                <path
                                    d="M5.49094 5.0045C5.49167 5.06345 5.47995 5.12191 5.45655 5.17611C5.43315 5.2303 5.39858 5.27904 5.35507 5.31918L1.27899 9.36513C1.09783 9.54496 0.817029 9.54496 0.63587 9.36513C0.45471 9.18531 0.45471 8.90659 0.63587 8.72677L4.39493 4.9955L0.644928 1.27323C0.463768 1.09341 0.463768 0.814685 0.644928 0.634865C0.826087 0.455045 1.10688 0.455045 1.28804 0.634865L5.36413 4.68082C5.45471 4.77073 5.5 4.88761 5.5 4.9955L5.49094 5.0045Z"
                                    fill="currentColor" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
